import { SortByTypeEnum } from "../../enums/list-layout/sort-type-enum";

export class SortByValuesModel {
    ascSortValue: SortByTypeEnum = SortByTypeEnum.Asc;
    descSortValue: SortByTypeEnum = SortByTypeEnum.Desc;
    defaultSortValue: SortByTypeEnum =  SortByTypeEnum.None;
    altSearchFieldName: string |undefined = undefined; 

    constructor(altSearchFieldName?: string){
        this.altSearchFieldName = altSearchFieldName;
    }
}
